// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2DAoK","containerItemsCenter":"Skeleton_containerItemsCenter__3KHyC"};